import { render, staticRenderFns } from "./FooterSocials.vue?vue&type=template&id=cf9efbc2&"
import script from "./FooterSocials.vue?vue&type=script&lang=js&"
export * from "./FooterSocials.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports